/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { FermetureExceptionnelleDto } from '../models/fermeture-exceptionnelle-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des fermetures exceptionnelles des recyparcs
 */
@Injectable({
  providedIn: 'root',
})
export class FermeturesExceptionnellesRecyparcsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fermetureExceptionnelleGetList
   */
  static readonly FermetureExceptionnelleGetListPath = '/api/fermetures-exceptionnelles-recyparcs/list/{parcId}';

  /**
   * Renvoie la liste des fermetures exceptionnelles du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fermetureExceptionnelleGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  fermetureExceptionnelleGetList$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<StrictHttpResponse<Array<FermetureExceptionnelleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, FermeturesExceptionnellesRecyparcsService.FermetureExceptionnelleGetListPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FermetureExceptionnelleDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des fermetures exceptionnelles du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fermetureExceptionnelleGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fermetureExceptionnelleGetList(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<Array<FermetureExceptionnelleDto>> {

    return this.fermetureExceptionnelleGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FermetureExceptionnelleDto>>) => r.body as Array<FermetureExceptionnelleDto>)
    );
  }

  /**
   * Path part for operation fermetureExceptionnelleLoadList
   */
  static readonly FermetureExceptionnelleLoadListPath = '/api/fermetures-exceptionnelles-recyparcs/load-list/{parcId}';

  /**
   * Renvoie la liste des fermetures exceptionnelles du recyparc spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fermetureExceptionnelleLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fermetureExceptionnelleLoadList$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, FermeturesExceptionnellesRecyparcsService.FermetureExceptionnelleLoadListPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des fermetures exceptionnelles du recyparc spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fermetureExceptionnelleLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fermetureExceptionnelleLoadList(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.fermetureExceptionnelleLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation fermetureExceptionnelleGet
   */
  static readonly FermetureExceptionnelleGetPath = '/api/fermetures-exceptionnelles-recyparcs/{id}';

  /**
   * Renvoie la fermeture exceptionnelle spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fermetureExceptionnelleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  fermetureExceptionnelleGet$Response(params: {

    /**
     * Identifiant de la fermeture exceptionnelle
     */
    id: number;
  }): Observable<StrictHttpResponse<FermetureExceptionnelleDto>> {

    const rb = new RequestBuilder(this.rootUrl, FermeturesExceptionnellesRecyparcsService.FermetureExceptionnelleGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FermetureExceptionnelleDto>;
      })
    );
  }

  /**
   * Renvoie la fermeture exceptionnelle spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fermetureExceptionnelleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fermetureExceptionnelleGet(params: {

    /**
     * Identifiant de la fermeture exceptionnelle
     */
    id: number;
  }): Observable<FermetureExceptionnelleDto> {

    return this.fermetureExceptionnelleGet$Response(params).pipe(
      map((r: StrictHttpResponse<FermetureExceptionnelleDto>) => r.body as FermetureExceptionnelleDto)
    );
  }

  /**
   * Path part for operation fermetureExceptionnellePut
   */
  static readonly FermetureExceptionnellePutPath = '/api/fermetures-exceptionnelles-recyparcs/{id}';

  /**
   * Met à jour la fermeture exceptionnelle spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fermetureExceptionnellePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fermetureExceptionnellePut$Response(params: {

    /**
     * Identifiant de la fermeture exceptionnelle
     */
    id: number;

    /**
     * Fermeture exceptionnelle
     */
    body: FermetureExceptionnelleDto
  }): Observable<StrictHttpResponse<FermetureExceptionnelleDto>> {

    const rb = new RequestBuilder(this.rootUrl, FermeturesExceptionnellesRecyparcsService.FermetureExceptionnellePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FermetureExceptionnelleDto>;
      })
    );
  }

  /**
   * Met à jour la fermeture exceptionnelle spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fermetureExceptionnellePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fermetureExceptionnellePut(params: {

    /**
     * Identifiant de la fermeture exceptionnelle
     */
    id: number;

    /**
     * Fermeture exceptionnelle
     */
    body: FermetureExceptionnelleDto
  }): Observable<FermetureExceptionnelleDto> {

    return this.fermetureExceptionnellePut$Response(params).pipe(
      map((r: StrictHttpResponse<FermetureExceptionnelleDto>) => r.body as FermetureExceptionnelleDto)
    );
  }

  /**
   * Path part for operation fermetureExceptionnelleDelete
   */
  static readonly FermetureExceptionnelleDeletePath = '/api/fermetures-exceptionnelles-recyparcs/{id}';

  /**
   * Supprime la fermeture exceptionnelle spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fermetureExceptionnelleDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  fermetureExceptionnelleDelete$Response(params: {

    /**
     * Identifiant de la fermeture exceptionnelle
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, FermeturesExceptionnellesRecyparcsService.FermetureExceptionnelleDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la fermeture exceptionnelle spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fermetureExceptionnelleDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fermetureExceptionnelleDelete(params: {

    /**
     * Identifiant de la fermeture exceptionnelle
     */
    id: number;
  }): Observable<number> {

    return this.fermetureExceptionnelleDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation fermetureExceptionnellePost
   */
  static readonly FermetureExceptionnellePostPath = '/api/fermetures-exceptionnelles-recyparcs/{parcId}';

  /**
   * Crée une fermeture exceptionnelle pour le recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fermetureExceptionnellePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fermetureExceptionnellePost$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Fermeture exceptionnelle
     */
    body: FermetureExceptionnelleDto
  }): Observable<StrictHttpResponse<FermetureExceptionnelleDto>> {

    const rb = new RequestBuilder(this.rootUrl, FermeturesExceptionnellesRecyparcsService.FermetureExceptionnellePostPath, 'post');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FermetureExceptionnelleDto>;
      })
    );
  }

  /**
   * Crée une fermeture exceptionnelle pour le recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fermetureExceptionnellePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fermetureExceptionnellePost(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;

    /**
     * Fermeture exceptionnelle
     */
    body: FermetureExceptionnelleDto
  }): Observable<FermetureExceptionnelleDto> {

    return this.fermetureExceptionnellePost$Response(params).pipe(
      map((r: StrictHttpResponse<FermetureExceptionnelleDto>) => r.body as FermetureExceptionnelleDto)
    );
  }

}
